import monkeyPatchBaseView from "shared/invoca_app/monkey_patch_base_view";
import installGlobalAjaxComplete from "shared/invoca_app/install_global_ajax_complete";
import configureDataTables from "shared/invoca_app/configure_data_tables";
import InvocaApp from "shared/invoca_app";

import InvocaCollection from "shared/invoca_collection";
import BaseModel from "shared/base_model";

import Config from "legacy/config";

import Backdraft from "backdraft-app/src/backdraft";
import App from "backdraft-app/src/app";

import _ from "underscore";

function overrideBasePluginModelDefiner(app) {
  const oldModel = app.model;

  app.model = function(name, baseClassName, properties) {
    oldModel.apply(this, arguments);
    if (arguments.length === 2 && !_.has(arguments[1], "url")) {
      app.Models[name].prototype.url = BaseModel.prototype.url;
    }
  };
}

Backdraft.plugin("InvocaApp", plugin => {
  plugin.initializer(app => {
    app.installPlugin("Base");

    installGlobalAjaxComplete();
    configureDataTables(app);

    overrideBasePluginModelDefiner(app);

    app.Collections.InvocaCollection = InvocaCollection;

    monkeyPatchBaseView();

    const baseMethods = _.pick(InvocaApp.prototype,
      'link',
      'installLinkHandler',
      'uninstallLinkHandler',
      'navigate',
      'navigateTo',
      'createActionTable',
      'addHeaderTooltips'
    );

    _.extend(app, baseMethods);

    _.extend(app, {
      nameForAdvertiser(lowercase, plural, possessive, spacesNotUnderscores) {
        const method = Config.localization.advertiserNameFromNetwork;
        return method.toString(...arguments);
      },

      nameForAffiliate(lowercase, plural, possessive, spacesNotUnderscores) {
        const method = Config.localization.affiliateNameFromNetwork;
        return method.toString(...arguments);
      },

      advertiserIdFriendlyName() {
        return Config.localization.advertiserIdFriendlyName;
      },

      affiliateIdFriendlyName() {
        return Config.localization.affiliateIdFriendlyName;
      },

      advertiserCampaignIdName() {
        return Config.localization.advertiserCampaignIdName;
      },

      advertiserCampaignIdFriendlyName() {
        return Config.localization.advertiserCampaignIdFriendlyName;
      }
    });

    // use destroy from base class if it's using the default implementation
    if (app.destroy === App.prototype.destroy) {
      _.extend(app, {
        destroy: InvocaApp.prototype.destroy
      });

      // Fill in the rest of the interface expected by InvocaApp#onDestroy

      if (!app.onDestroy) {
        _.extend(app, {
          onDestroy() {
          }
        });
      }
    }

    // use activate from base class if it's using the default implementation
    if (app.activate === App.prototype.activate) {
      _.extend(app, {
        activate: InvocaApp.prototype.activate
      });

      // Fill in the rest of the interface expected by InvocaApp#activate

      if (!app.createMainRouter) {
        _.extend(app, {
          createMainRouter() {
            return new this.Routers.Main({ $el: this.$el });
          }
        });
      }

      if (!app.onActivate) {
        _.extend(app, {
          onActivate() {
          }
        });
      }
    }
  });
});
